module.exports = __webpack_public_path__ + "img/hanguo.3ec43266.png";